import {ReactComponent as IsraeliFlag} from 'assets/svgs/israeli_flag.svg'
import {ReactComponent as AmericanFlag} from 'assets/svgs/american_flag.svg'

const Svgs = {IsraeliFlag, AmericanFlag}
export default Svgs
